const IconEditContact = ({ className }) => {
    return (
        <svg
            width='25'
            height='25'
            viewBox='0 0 25 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path d='M12.8989 20.1858H21.9235' strokeWidth='2.00546' strokeLinecap='round' strokeLinejoin='round' />
            <path
                d='M17.4114 3.64071C17.8103 3.2418 18.3513 3.01769 18.9155 3.01769C19.1948 3.01769 19.4714 3.07271 19.7295 3.17961C19.9876 3.28651 20.2221 3.44319 20.4196 3.64071C20.6171 3.83823 20.7738 4.07272 20.8807 4.3308C20.9876 4.58887 21.0426 4.86547 21.0426 5.14481C21.0426 5.42415 20.9876 5.70075 20.8807 5.95882C20.7738 6.2169 20.6171 6.45139 20.4196 6.64891L7.88544 19.1831L3.87451 20.1858L4.87724 16.1749L17.4114 3.64071Z'
                strokeWidth='2.00546'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconEditContact;
